import Crud from '../views/SituacaoTransporte/Crud'
import Entity from '../views/SituacaoTransporte/Add'

let routes = {
    path: '/situacao_transporte',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/situacao_transporte/add',
            name: 'NewCbo',
            component: Entity
        },
        {
            path: '/situacao_transporte/edit/:id?',
            name: 'EditCbo',
            component: Entity
        },
        {
            path: '/situacao_transporte',
            name: 'list-situacao-transporte',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Situações dos Transportes',
                breadcrumb: [
                    {
                        text: 'Situação do Transporte',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
